<template>
  <div class="input-group d-flex align-center justify-space-between">
    <label v-text="label" />

    <v-btn
      class="toggle-btn rounded-0 font-weight-bold"
      :class="{active: value}"
      :ripple="false" depressed height="32"
      @click="$emit('input', !value)"
    >
      {{ value ? $t('common.on') : $t('common.off') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.toggle-btn {
  width: 220px + 35px + 8px + 9px;
  background-color: grey(500) !important;

  &.active {
    background-color: grey(400) !important;
  }
}

label {
  color: #cecece;
  text-transform: uppercase;
}

.v-input__slider ::v-deep {
  .v-input__slot {
    justify-content: space-between;
  }

  .v-slider__track-container,
  .v-slider__ticks-container {
    height: 8px !important;
  }

  .v-slider__tick {
    top: calc(50% - 4px) !important;
    height: 8px !important;
  }

  label + .v-slider {
    max-width: 220px;
  }

  .v-slider__thumb {
    height: 28px;
    border: 2px solid #cecece !important;
    border-radius: 0;

    &::before {
      display: none;
    }
  }

  .v-input__append-outer {
    align-self: stretch;
    align-items: center;
  }

  .value-label {
    width: 50px;
  }
}

</style>
